module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE1MSIgdmlld0JveD0iMCAwIDMwMSAxNTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRDYyODI4IiBkPSJNLjUuNWgzMDB2MTUwSC41eiIvPjxwYXRoIGZpbGw9IiNGQ0Q4NTYiIGQ9Ik0uNS41aDIwMGwtMjAwIDE1MHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMzAwLjUgNTAuNXYxMDBILjV6Ii8+PHBhdGggZmlsbD0iIzAwM0Y4NyIgZD0iTS41LjVoMTAwbC0xMDAgMTUweiIvPjxwYXRoIGZpbGw9IiMwMDdBM0QiIGQ9Ik0uNSAxNTAuNWgzMDB2LTUweiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-sc.svg
// module id = z51k
// module chunks = 2